"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRegisterResources = void 0;
var react_1 = require("react");
var renderer_provider_1 = require("../renderer-provider");
var useRegisterResources = function () {
    var resourceContext = (0, renderer_provider_1.useRendererContext)().resourceContext;
    var registerImage = (0, react_1.useCallback)(function (_a) {
        var imageUrl = _a.imageUrl, imageElement = _a.imageElement;
        resourceContext.registerImage(imageUrl, {
            imageUrl: imageUrl,
            imageElement: imageElement,
        });
    }, []);
    var registerFont = (0, react_1.useCallback)(function (_a) {
        var fontUrl = _a.fontUrl, fontFamily = _a.fontFamily, fontMetrics = _a.fontMetrics;
        resourceContext.registerFont({ fontUrl: fontUrl, fontMetrics: fontMetrics }, { fontFamily: fontFamily, fontMetrics: fontMetrics, bytes: new Uint8Array() });
    }, []);
    return { registerImage: registerImage, registerFont: registerFont };
};
exports.useRegisterResources = useRegisterResources;
